export default [
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path:
        [
            'textures/environmentMap/px.jpg',
            'textures/environmentMap/nx.jpg',
            'textures/environmentMap/py.jpg',
            'textures/environmentMap/ny.jpg',
            'textures/environmentMap/pz.jpg',
            'textures/environmentMap/nz.jpg'
        ]
    },
    {
        name: 'grassColorTexture',
        type: 'texture',
        path: 'textures/dirt/color.jpg'
    },
    {
        name: 'grassNormalTexture',
        type: 'texture',
        path: 'textures/dirt/normal.jpg'
    },
    {
        name: 'portalColorTexture',
        type: 'texture',
        path: 'textures/portal/portalColor.png'
    },
    {
        name: 'buildingModel',
        type: 'gltfModel',
        path: 'models/building/building.gltf'
    },
    {
        name: 'portalModel',
        type: 'gltfModel',
        path: 'models/portal/portal.glb'
    },
    {
        name: 'portalModelCone',
        type: 'gltfModel',
        path: 'models/Cone/CONE-2k.glb'
    },
    {
        name: 'buildingAModel',
        type: 'gltfModel',
        path: 'models/building/buildingA.glb'
    },
    {
        name: 'buildingBModel',
        type: 'gltfModel',
        path: 'models/building/buildingB.glb'
    },
    {
        name: 'buildingCModel',
        type: 'gltfModel',
        path: 'models/building/buildingC.glb'
    },
    {
        name: 'buildingDModel',
        type: 'gltfModel',
        path: 'models/building/buildingD.glb'
    },
    {
        name: 'buildingEModel',
        type: 'gltfModel',
        path: 'models/building/buildingE.glb'
    },
    {
        name: 'buildingFModel',
        type: 'gltfModel',
        path: 'models/building/buildingF.glb'
    },
    {
        name: 'buildingGModel',
        type: 'gltfModel',
        path: 'models/building/buildingG.glb'
    },
    {
        name: 'buildingHModel',
        type: 'gltfModel',
        path: 'models/building/buildingH.glb'
    },
    {
        name: 'axolotlModel',
        type: 'gltfModel',
        path: 'models/axolotl/axolotl-colored.glb'
    },
    {
        name: 'carModelWhite',
        type: 'gltfModel',
        path: 'models/car/car-custom-white.glb'
    },
    {
        name: 'carModelBlue',
        type: 'gltfModel',
        path: 'models/car/car-custom-blue.glb'
    },
    {
        name: 'carModelOrange',
        type: 'gltfModel',
        path: 'models/car/car-custom-orange.glb'
    },
    {
        name: 'carModelPurple',
        type: 'gltfModel',
        path: 'models/car/car-custom-purple.glb'
    },
    {
        name: 'carModelRed',
        type: 'gltfModel',
        path: 'models/car/car-custom-red.glb'
    },
    {
        name: 'carModelGreen',
        type: 'gltfModel',
        path: 'models/car/car-custom-green.glb'
    },
    {
        name: 'helicopterModel',
        type: 'gltfModel',
        path: 'models/helicopter/Helicopter.glb'
    },
    {
        name: 'baseModel',
        type: 'gltfModel',
        path: 'models/base/base-tex-noshader.glb'
    },
    {
        name: 'tileMilkyTexture1',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 1 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture2',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 2 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture3',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 3 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture4',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 4 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture5',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 5 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture6',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 6 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture7',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 7 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture8',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 8 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture9',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 9 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture10',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 10 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture11',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 11 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture12',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 12 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture13',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 13 - 512x512.png'
    },
    {
        name: 'tileMilkyTexture14',
        type: 'texture',
        path: 'textures/tiles/Milky/Milky 14 - 512x512.png'
    },
    {
        name: 'tileCratersTexture1',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 1 - 512x512.png'
    },
    {
        name: 'tileCratersTexture2',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 2 - 512x512.png'
    },
    {
        name: 'tileCratersTexture3',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 3 - 512x512.png'
    },
    {
        name: 'tileCratersTexture4',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 4 - 512x512.png'
    },
    {
        name: 'tileCratersTexture5',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 5 - 512x512.png'
    },
    {
        name: 'tileCratersTexture6',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 6 - 512x512.png'
    },
    {
        name: 'tileCratersTexture7',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 7 - 512x512.png'
    },
    {
        name: 'tileCratersTexture8',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 8 - 512x512.png'
    },
    {
        name: 'tileCratersTexture9',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 9 - 512x512.png'
    },
    {
        name: 'tileCratersTexture10',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 10 - 512x512.png'
    },
    {
        name: 'tileCratersTexture11',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 11 - 512x512.png'
    },
    {
        name: 'tileCratersTexture12',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 12 - 512x512.png'
    },
    {
        name: 'tileCratersTexture13',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 13 - 512x512.png'
    },
    {
        name: 'tileCratersTexture14',
        type: 'texture',
        path: 'textures/tiles/Craters/Craters 14 - 512x512.png'
    },
    {
        name: 'skyTexture',
        type: 'texture',
        path: 'textures/sky/sky-color.png'
    }
]